export const themes = ['default', 'dnb', 'posten', 'postenBring'] as const;
export type Themes = (typeof themes)[number];

type FontDefinition =
    | {
          family: string;
          weight: string;
          url: string;
          fontSrc?: never;
      }
    | {
          family: string;
          weight: string;
          url?: never;
          fontSrc: string;
      };

export const fontsConfig: Array<{
    themeName: Themes;
    mainFontFamily: string;
    fonts: Array<FontDefinition>;
}> = [
    {
        themeName: 'default',
        mainFontFamily: 'DM Sans',
        // We load this by default, at some point we should ony load this if the theme is default, bc now we load our fonts + clients fonts
        fonts: [],
    },
    {
        themeName: 'dnb',
        mainFontFamily: 'DNB Regular',
        fonts: [
            {
                family: 'DNB Regular',
                weight: 'normal',
                url: 'https://eufemia.dnb.no/fonts/dnb/DNB-Regular.woff2',
            },
        ],
    },
    {
        themeName: 'posten',
        mainFontFamily: 'PostenSans',
        fonts: [
            {
                family: 'PostenSans',
                weight: 'normal',
                url: 'https://cdn.jsdelivr.net/gh/ux-signals/customer-fonts@main/fonts/posten/PostenSans-Regular.woff2',
            },
            {
                family: 'PostenSansBold',
                weight: 'bold',
                url: 'https://cdn.jsdelivr.net/gh/ux-signals/customer-fonts@main/fonts/posten/PostenSans-Bold.woff2',
            },
        ],
    },
    {
        themeName: 'postenBring',
        mainFontFamily: 'PostenSans',
        fonts: [
            {
                family: 'PostenSans',
                weight: 'normal',
                url: 'https://cdn.jsdelivr.net/gh/ux-signals/customer-fonts@main/fonts/posten/PostenSans-Regular.woff2',
            },
            {
                family: 'PostenSansMedium',
                weight: 'medium',
                url: 'https://cdn.jsdelivr.net/gh/ux-signals/customer-fonts@main/fonts/posten/PostenSans-Medium.woff2',
            },
        ],
    },
];
